/* v25: initialize after children exist; clean timers on section replacement. */
function debounce(fn, wait = 300) {
  let timer;
  return function (...args) { clearTimeout(timer); timer = setTimeout(() => fn.apply(this, args), wait); };
}
if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() { super(); this.run = 0; }
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.input) return;
        const connect = () => {
          const input = this.querySelector('.header__search-bar-input');
          if (!input) return false;
          this.waitForChildren?.disconnect(); this.waitForChildren = null;
          this.input = input; this.abort = new AbortController();
          this.input.addEventListener('input', () => {
            clearTimeout(this.inputTimer);
            this.inputTimer = setTimeout(() => { if (this.isConnected) this.handleInput(); }, 300);
          }, { signal: this.abort.signal });
          this.handleInput(); this.init(); return true;
        };
        if (!connect()) {
          this.waitForChildren = new MutationObserver(connect);
          this.waitForChildren.observe(this, { childList: true, subtree: true });
        }
      });
    }
    disconnectedCallback() {
      this.run++;
      this.abort?.abort(); this.abort = null;
      this.waitForChildren?.disconnect(); this.waitForChildren = null;
      clearTimeout(this.inputTimer); clearTimeout(this.typingTimer);
      if (this.resolveDelay) { this.resolveDelay(); this.resolveDelay = null; }
      // Preserve the original prompt if Shopify reuses this same element later.
      if (this.input && this.originalPlaceholder !== undefined) this.input.placeholder = this.originalPlaceholder;
      this.input = null;
    }
    init() {
      if (!this.input) return;
      const matches = window.theme && window.theme.mediaMatches;
      const desktop = matches && typeof matches.md === 'boolean' ? matches.md : window.matchMedia('(min-width:768px)').matches;
      if ((this.input.dataset.placeholderTwo || this.input.dataset.placeholderThree) &&
          (this.input.dataset.placeholderPromptsMob === 'true' || desktop)) this.typeInPlaceholders();
    }
    typeInPlaceholders() {
      const input = this.input;
      this.originalPlaceholder = input.getAttribute('placeholder') || '';
      const prompts = [this.originalPlaceholder];
      ['Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten'].forEach(name => {
        const value = input.dataset['placeholder' + name]; if (value) prompts.push(value);
      });
      const placeholders = [...new Set(prompts.filter(Boolean))];
      if (placeholders.length < 2) return;
      const duration = (key, fallback) => {
        const value = Number(input.dataset[key]);
        return Number.isFinite(value) && value >= 0 && input.dataset[key] !== undefined ? value : fallback;
      };
      const typing = Math.max(20, duration('typingSpeed',100));
      const deleting = Math.max(20, duration('deletingSpeed',60));
      const afterDelete = duration('delayAfterDeleting',500);
      const firstDelay = duration('delayBeforeFirstDelete',2000);
      const afterWord = duration('delayAfterWordTyped',2400);
      const token = ++this.run;
      const active = () => this.isConnected && this.run === token && this.input === input;
      const sleep = ms => new Promise(resolve => {
        this.resolveDelay = resolve;
        this.typingTimer = setTimeout(() => { this.resolveDelay = null; resolve(); }, ms);
      });
      const animate = async () => {
        let index = 0;
        await sleep(firstDelay);
        while (active()) {
          index = (index + 1) % placeholders.length;
          const next = placeholders[index];
          let current = input.getAttribute('placeholder') || '';
          while (active() && current.length && !(current.length >= 3 && next.startsWith(current))) {
            current = current.slice(0,-1); input.setAttribute('placeholder',current); await sleep(deleting);
          }
          if (!active()) return;
          await sleep(afterDelete);
          while (active() && current.length < next.length) {
            current = next.slice(0,current.length + 1); input.setAttribute('placeholder',current); await sleep(typing);
          }
          if (!active()) return;
          await sleep(afterWord);
        }
      };
      animate().catch(error => console.warn('Search placeholder animation stopped',error));
    }
    handleInput() { if (this.input) this.input.classList.toggle('search__input--dirty', this.input.value.length > 0); }
    handleProductTypeChange(evt) {
      if (this.productTypeInput && evt.detail) this.productTypeInput.value = evt.detail.selectedValue;
    }
    handleReset() { if (this.input) this.input.classList.remove('search__input--dirty'); }
  }
  customElements.define('search-form', SearchForm);
}
